export class EnrollContacts {
  phone: string = '';
  mail: string = '';
  vk_profile: string = '';
  fb_profile: string = '';
  insta_profile: string = '';
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-contacts.ts